import type { ReactNode } from 'react';
import { Skeleton } from '@/components/ui/Skeleton';
import { useFilterMemory } from '@/lib/filter-memory/use-filter-memory';

/**
 * Filter memory's single mount point (owner rulings 2026-10-16; read
 * `lib/filter-memory/index.ts`). Wraps the PAGE inside `Shell`, never the
 * chrome: the sidebar and top bar stay on screen while the page is held back
 * to restore a remembered address — usually one pass, at most a few seconds
 * on a device that has never loaded the account's memory.
 */
export function FilterMemory({ children }: { children: ReactNode }) {
  const ready = useFilterMemory();
  if (ready) return <>{children}</>;
  return (
    <div className="space-y-3 p-4" aria-busy="true">
      <Skeleton className="h-7 w-48" />
      <Skeleton className="h-9 w-full" />
      <Skeleton className="h-64 w-full" />
    </div>
  );
}
